import React from "react"
import { Link } from "gatsby"

const ProductHeaderBreadcrumbs = ({ breadcrumbs, _uid }) => {
  return (
    <section
      className="relative border-t border-1 border-gray-200 py-4"
      data-product-obj-id={_uid}
    >
      <div className="mx-auto max-w-screen-xl px-grid">
        <div className="flex flex-row flex-wrap h-full -mx-grid">
          <div className="w-full py-1 md:w-1/2 lg:w-3/5 px-grid">
            <div className="block mb-2 -ml-2 text-sm">
              {breadcrumbs?.map((breadcrumb, index) => {
                return (
                  <span key={index}>
                    {index > 0 && <span className="inline-block h-4">/</span>}
                    <Link
                      className={`px-2 hover:underline`}
                      key={index}
                      to={breadcrumb.link}
                    >
                      {breadcrumb.link_text}
                    </Link>
                  </span>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductHeaderBreadcrumbs
